import React, { useEffect, useState, useRef } from 'react'
import '.././App.css';
import Swal from 'sweetalert2';
import { auth, db } from '../firebase';
import { collection, query, orderBy, onSnapshot, getDoc, doc, where, getAggregateFromServer, sum, getDocs, } from 'firebase/firestore'
import moment from 'moment';
import Select from 'react-select'
import { useReactToPrint } from 'react-to-print';


export default function Categorywise() {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });
    const [userData, setUserData] = useState();

    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            setUserData(user);
        });
    });

   

    const printRef = useRef();
    const [reportData, setreportData] = useState([]);
    const [prodCat, setprodCat] = useState("");
    const [fromdate, setfromdate] = useState("");
    const [todate, settodate] = useState("");
    const [totalamount, settotalamount] = useState("");
    const [productCat, setproductCat] = useState([]);

     useEffect(() => {
        const today = new Date();
        const formattedDate = today.toISOString().split('T')[0];
        setfromdate(formattedDate);
        settodate(formattedDate);
        fetchData1()
    }, []);

    const handlePrint = useReactToPrint({
        content: () => printRef.current,
    })

    const fetchData1 = async () => {
        try {
            const q = query(collection(db, 'productcats'))
            onSnapshot(q, (querySnapshot) => {
                setproductCat(querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data()
                })));
            });
        } catch (error) {
            Toast.fire({
                icon: "error",
                title: error.message
            });
        }
    }


    const getReport = async () => {
        settotalamount(0);
        setreportData([]);

        if (!prodCat || !fromdate) {
            Toast.fire({
                icon: "error",
                title: 'Please Select Date and Product Category'
            });
            return;
        }

        try {
            // Step 1: Fetch products that match selected category
            const prodQuery = query(collection(db, 'products'), where('prodcatid', '==', prodCat));
            const prodSnapshot = await getDocs(prodQuery);
            const validProductNames = new Set();

            prodSnapshot.forEach(doc => {
                validProductNames.add(doc.data().prodname); // or .itemname depending on your structure
            });

            // If no products found in selected category, stop
            if (validProductNames.size === 0) {
                Toast.fire({ icon: "warning", title: 'No products found in this category' });
                return;
            }

            // Step 2: Fetch orderitems for the given date
            const q1 = query(collection(db, 'productwisesale'), where('orderdate', '>=', fromdate), where('orderdate', '<=', todate));

            onSnapshot(q1, (querySnapshot1) => {
                const productMap = new Map();
                let totalAmount = 0;

                querySnapshot1.forEach((doc1) => {
                    const data = doc1.data();
                    const key = data.itemname;

                    // Filter by matching item name in valid products
                    if (!validProductNames.has(key)) return;

                    if (!productMap.has(key)) {
                        productMap.set(key, {
                            itemname: key,
                            rate: parseFloat(data.rate),
                            quantity: parseFloat(data.quantity),
                            total: parseFloat(data.rate) * parseFloat(data.quantity),
                        });
                    } else {
                        const existing = productMap.get(key);
                        existing.quantity += parseFloat(data.quantity);
                        existing.total += parseFloat(data.rate) * parseFloat(data.quantity);
                    }

                    totalAmount += parseFloat(data.rate) * parseFloat(data.quantity);
                });

                // Convert Map to Array and sort alphabetically
                const combinedData = Array.from(productMap.values()).sort((a, b) =>
                    a.itemname.localeCompare(b.itemname)
                );

                settotalamount(totalAmount.toFixed(2));
                setreportData(combinedData);
            });

        } catch (error) {
            console.error("Error generating report:", error);
            Toast.fire({ icon: "error", title: 'Something went wrong!' });
        }
    };



    return (
        <div>
            <div className="content-wrapper">
                <section className="content">
                    <div className="container-fluid">
                        <button className="btn btn-secondary" style={{ float: "right" }} >|| Category Wise Report  ||</button><br /><br />
                        <div className="card card-primary card-outline">
                            <div className="card-body table-responsive p-3" >
                                <div className='row '>
                                    <div className="col-sm-3">
                                        <label> Select Category </label>
                                        <select className='form-control' value={prodCat} onChange={(e) => setprodCat(e.target.value)}>
                                            <option></option>
                                            {
                                                productCat.map((item, index) =>
                                                    <option key={index} value={item.id}>{item.data.catname}</option>
                                                )
                                            }
                                        </select>
                                    </div>
                                    <div className="col-sm-3">
                                        <label>From Date </label>
                                        <input type="date" className="form-control" style={{ height: 35, fontSize: 14 }} value={fromdate} onChange={(e) => setfromdate(e.target.value)} />
                                    </div>
                                    <div className="col-sm-3">
                                        <label> To Date </label>
                                        <input type="date" className="form-control" style={{ height: 35, fontSize: 14 }} value={todate} onChange={(e) => settodate(e.target.value)} />
                                    </div>
                                    <div className='col-sm-3'>
                                        <br />
                                        <button onClick={() => getReport()} className='btn btn-info'>Get Report</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="card card-primary card-outline">
                            <div className="card-body table-responsive p-3" ref={printRef}>
                                <center>
                                    <h6>Pratik Bar</h6>
                                    <span>Tuljapur By Pass, Bhavani Chouk, Dharashiv, 413601</span><br />
                                    {/* <span>Mobile No: 9921060146</span> */}
                                </center><hr />
                                <div className='row'>
                                    <div className='col-sm-4'>
                                        <span><b>From Date : </b>{moment(fromdate).format('DD/MM/YYY')}</span>
                                    </div>
                                    <div className='col-sm-4 text-center'>
                                        <h6 style={{ textTransform: "uppercase" }}>Category Wise Report</h6>
                                    </div>
                                    <div className='col-sm-4' style={{textAlign:"right"}}>
                                        <span><b>To Date : </b>{moment(todate).format('DD/MM/YYY')}</span>
                                    </div>
                                </div>
                                <div className='row '>
                                    <table className='table table-striped'>
                                        <thead>
                                            <tr>
                                                <th>Sr No</th>
                                                <th>Date</th>
                                                <th>Product Name</th>
                                                <th>Rate</th>
                                                <th>Quantity</th>
                                                <th>Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                reportData.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{moment(fromdate).format('DD-MM-YYYY')}</td>
                                                        <td>{item.itemname}</td>
                                                        <td>{item.rate}</td>
                                                        <td>{item.quantity}</td>
                                                        <td>{item.total.toFixed(2)}</td>
                                                    </tr>
                                                ))
                                            }

                                            <tr>
                                                <td colSpan={4}><b>Total</b></td>
                                                <td><b>
                                                    {
                                                        reportData.reduce((sum, item) => sum + parseFloat(item.quantity), 0)
                                                    }
                                                </b></td>
                                                <td><b>{totalamount}</b></td>
                                            </tr>
                                        </tbody>
                                    </table>

                                </div>
                            </div>
                            <center>
                                <button onClick={handlePrint} className='btn btn-info'>Print Report</button>
                            </center><br />
                        </div>
                    </div>
                </section>
            </div>
        </div>
    )
}
